import createIcon from '../../createIcon';

/**
 * @component @name Hls
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi43NSA5SDguMjVWMTVINi43NVYxMi41SDQuNzVWMTVIMy4yNVY5SDQuNzVWMTFINi43NVY5Wk0xNi43NSAxNUgxOS43NUMyMC4zIDE1IDIwLjc1IDE0LjU1IDIwLjc1IDE0VjEyLjVDMjAuNzUgMTEuOTUgMjAuMyAxMS41IDE5Ljc1IDExLjVIMTcuMjVWMTAuNUgxOS4yNVYxMUgyMC43NVYxMEMyMC43NSA5LjQ1IDIwLjMgOSAxOS43NSA5SDE2Ljc1QzE2LjIgOSAxNS43NSA5LjQ1IDE1Ljc1IDEwVjExLjVDMTUuNzUgMTIuMDUgMTYuMiAxMi41IDE2Ljc1IDEyLjVIMTkuMjVWMTMuNUgxNy4yNVYxM0gxNS43NVYxNEMxNS43NSAxNC41NSAxNi4yIDE1IDE2Ljc1IDE1Wk0xNC4yNSAxNVYxMy41SDExLjc1VjlIMTAuMjVWMTVIMTQuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hls = createIcon('Hls', [
  [
    'path',
    {
      d: 'M6.75 9H8.25V15H6.75V12.5H4.75V15H3.25V9H4.75V11H6.75V9ZM16.75 15H19.75C20.3 15 20.75 14.55 20.75 14V12.5C20.75 11.95 20.3 11.5 19.75 11.5H17.25V10.5H19.25V11H20.75V10C20.75 9.45 20.3 9 19.75 9H16.75C16.2 9 15.75 9.45 15.75 10V11.5C15.75 12.05 16.2 12.5 16.75 12.5H19.25V13.5H17.25V13H15.75V14C15.75 14.55 16.2 15 16.75 15ZM14.25 15V13.5H11.75V9H10.25V15H14.25Z',
      key: '152t37',
    },
  ],
]);

export default Hls;
